import { createContext } from 'react';
import {
    QUERY_KEYS_SIH,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.PROCEDURES_LIST,
            url: 'governanceroom/dashboard/sihsus/aih/procedureRanking'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
            city: filters.cidade?.value
        }
    );

    const chartData = data
        ? {
              counterProcedureRea: data.counterProcedureRea || [],
              counterProcedureSolic: data.counterProcedureSolic || [],
              counterDiagPrinc: data.counterDiagPrinc || []
          }
        : {
              counterProcedureRea: [],
              counterProcedureSolic: [],
              counterDiagPrinc: []
          };

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
